import React from 'react';
import FloorPlan from './FloorPlan';
import BookingPanel from './BookingPanel';
import DatePicker from './DatePicker';

/**
 * WebView - Desktop layout for browser and SharePoint iframe embedding.
 *
 * This is the cleaned-up version of the original App layout with
 * proper responsive breakpoints for desktop/laptop resolutions.
 * Landscape orientation, full floor plan with booking panel beside or below.
 */
export default function WebView({
  officeConfig,
  availability,
  selectedRoom,
  selectedDate,
  onDateChange,
  onRoomSelect,
  onBook,
  user,
  onLogin,
  onLogout,
  loading,
  error,
  onDismissError,
  bookingSuccess,
  onDismissSuccess,
  existingBooking,
  directBooking,
}) {
  return (
    <div className="web-view">
      {/* Header */}
      <header className="app-header">
        <div className="header-left">
          <img
            src={officeConfig.theme?.logo || '/logo-full.png'}
            alt={officeConfig.theme?.logoAlt || 'SSP Innovations'}
            className="header-logo"
          />
        </div>
        <div className="header-center">
          <span className="header-subtitle">{officeConfig.name} Office - Room Booking</span>
        </div>
        <div className="header-right">
          {user ? (
            <div className="user-info">
              <span className="user-name">{user.name}</span>
              <button className="logout-btn" onClick={onLogout}>Sign Out</button>
            </div>
          ) : (
            <button className="login-btn" onClick={onLogin}>
              Sign In with Microsoft
            </button>
          )}
        </div>
      </header>

      {/* Main content */}
      <main className="web-main">
        {!user ? (
          <div className="login-gate">
            <img src="/logo-color.png" alt="SSP Innovations" className="login-gate-logo" />
            <h2>{officeConfig.name} Office - Room Booking</h2>
            <p>Sign in with your SSP account to view availability and book spaces.</p>
            <button className="login-btn login-btn-large" onClick={onLogin}>
              Sign In with Microsoft
            </button>
          </div>
        ) : (
          <>
            <div className="web-date-bar">
              <DatePicker
                selectedDate={selectedDate}
                onDateChange={onDateChange}
              />
            </div>

            {error && (
              <div className="global-error">
                {error}
                <button onClick={onDismissError}>Dismiss</button>
              </div>
            )}

            {bookingSuccess && (
              <div className="booking-success">
                <h3>Booking Confirmed!</h3>
                <p>
                  {bookingSuccess.roomName} on{' '}
                  {new Date(bookingSuccess.date + 'T12:00:00').toLocaleDateString('en-US', {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                  })}
                </p>
                <p>A calendar invite has been sent to your inbox.</p>
                <button onClick={onDismissSuccess}>OK</button>
              </div>
            )}

            <div className="web-content">
              <div className="web-floorplan">
                <FloorPlan
                  officeConfig={officeConfig}
                  availability={availability}
                  onRoomSelect={onRoomSelect}
                  selectedRoom={selectedRoom}
                  isKiosk={false}
                />
              </div>

              {selectedRoom && (
                <div className="web-booking-panel">
                  <BookingPanel
                    selectedRoomId={selectedRoom}
                    availability={availability}
                    onBook={onBook}
                    onCancel={() => onRoomSelect?.(null)}
                    isKiosk={false}
                    existingBooking={existingBooking}
                    user={user}
                    directBooking={directBooking}
                    selectedDate={selectedDate}
                  />
                </div>
              )}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
